import type {
  QuickLinkDesignOneData,
  Imagedata,
  Linkdata,
} from '../../../components/AboutAmway/QuickLinkDesignOne/types/propsTypes';
import type { QuickLinkDesignOneProps } from '../../../components/AboutAmway/QuickLinkDesignOne/QuickLinkDesignOne';
import { ComponentType } from '../../registries/types/propTypes';
import { CMSTransformerDataType } from '../../types/common';
const transformQuickLinksDesignOne = (data: CMSTransformerDataType): QuickLinkDesignOneProps => {
  const quickLinksDesignOne = Array.isArray(data.quick_links_design_one)
    ? data.quick_links_design_one[0]
    : data.quick_links_design_one;

  const { quick_links_ } = quickLinksDesignOne || {};
  const quickLinkDesignOne: QuickLinkDesignOneData[] = [];

  quick_links_?.map((item: CMSTransformerDataType) => {
    const title = item.display_title;
    const imagedata: Imagedata = { url: item.image.url };
    const linkdata: Linkdata = {
      text: item.link.text,
      url: item.link.url,
      target: item.link.target,
    };
    quickLinkDesignOne.push({
      title,
      imagedata,
      linkdata,
    });
  });
  return {
    componentType: ComponentType.quick_links_design_one,
    quickLinks: quickLinkDesignOne,
  };
};

export default transformQuickLinksDesignOne;
